import { render, staticRenderFns } from "./AnnotationPreview.vue?vue&type=template&id=8df96efa&scoped=true&"
import script from "./AnnotationPreview.vue?vue&type=script&lang=js&"
export * from "./AnnotationPreview.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationPreview.vue?vue&type=style&index=0&id=8df96efa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df96efa",
  null
  
)

export default component.exports